if (!customElements.get('aa-product-information')) {
  customElements.define('aa-product-information', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.processed) return;
      const description = this.querySelector('[data-information-content="description"]');
      const material = this.querySelector('[data-information-content="material"]');
      const size = this.querySelector('[data-information-content="size"]');
      if (!description || !material || !size) return;
      this.dataset.processed = 'true';
      for (const block of description.querySelectorAll('[data-aa-information="material"]')) {
        material.append(block);
      }
      for (const block of description.querySelectorAll('[data-aa-information="size"]')) {
        size.append(block);
      }
      if (['SPOD', 'Spreadconnect'].includes(this.dataset.supplier)) {
        const tables = [...description.querySelectorAll('.size-table')].filter(table =>
          table.querySelector('.size-table-wrapper table') &&
          table.querySelector('img[src*="image.spreadshirtmedia.net/image-server/v1/productTypes/"]')
        );
        const lists = [...description.querySelectorAll('ul.listMCE')];
        for (const table of tables) {
          const previous = table.previousElementSibling;
          if (previous?.matches('ul') && !lists.includes(previous)) lists.push(previous);
        }
        let materialList;
        let sizeList;
        for (const list of lists) {
          for (const item of [...list.children]) {
            if (item.tagName !== 'LI' || item.querySelector('ul,ol,table,.size-table')) continue;
            const text = item.textContent.trim().replace(/\s+/g, ' ');
            const isMaterial = /^(?:Material|Futter):\s*\S/i.test(text) ||
              /^\d+(?:[.,]\d+)?\s*%\s+(?:Baumwolle|Ringgarn-Baumwolle|Polyester|Nylon|Bio-Baumwolle|cotton|ring-spun cotton)\b/i.test(text) ||
              /^(?:Super soft fabrics|Durable fabrics|Quality):\s*\d+\s*g\/m[²2]/i.test(text) ||
              /^(?:(?:Angenehm|Leichte|Legere|Solide|Strapazierfähige|Weiche|Softe|Schwere|Robuste|Kuschelige|Strukturierter|Robuster|Griffige|Feste|Blickdichte|Warmer|Sweatshirt-Stoff|Piqué-Stoff|Sweatstoff)[\wäöüß, -]* )?(?:Stoffqualität|Stoffdichte|Sweatstoff|Piqué-Stoff|Sweatshirt-Stoff):\s*.*\d+\s*g\/m[²2]/i.test(text);
            const isSize = /^(?:Maße|Größe|Fassungsvermögen):?\s*\d/i.test(text) ||
              /^Durchmesser ca\.\s*\d/i.test(text) || /^\d+ litres holding capacity$/i.test(text);
            if (isMaterial) {
              if (!materialList) { materialList = document.createElement('ul'); material.append(materialList); }
              materialList.append(item);
            } else if (isSize) {
              if (!sizeList) { sizeList = document.createElement('ul'); size.append(sizeList); }
              sizeList.append(item);
            }
          }
          if (!list.children.length && !list.textContent.trim()) list.remove();
        }
        if (this.dataset.productType === 'Baby T-Shirt') {
          const exactSuffix = 'Stoffdichte: 200g/m². 100% Baumwolle. (Grau meliert 85% Baumwolle/15% Polyester)';
          const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            if (node.textContent.trimEnd().endsWith(exactSuffix)) {
              const start = node.textContent.lastIndexOf(exactSuffix);
              const moved = node.splitText(start);
              const paragraph = document.createElement('p');
              paragraph.append(moved);
              material.append(paragraph);
              break;
            }
          }
        }
        for (const table of tables) {
          size.append(table);
          for (const header of table.querySelectorAll('thead th')) {
            header.scope = 'col';
            if (!header.textContent.trim()) header.textContent = this.querySelector('[data-information="size"] summary').childNodes[0].textContent.trim();
          }
          const scroller = table.querySelector('.size-table-wrapper');
          scroller.tabIndex = 0;
          scroller.setAttribute('role', 'region');
          scroller.setAttribute('aria-label', this.querySelector('[data-information="size"] summary').childNodes[0].textContent.trim());
        }
      }
      for (const [name, content] of [['description', description], ['material', material], ['size', size]]) {
        this.querySelector(`[data-information="${name}"]`).hidden = !content.textContent.trim() && !content.querySelector('img,table,video');
      }
    }
  });
}
